import {html, unsafeHTML, LitElement} from "../libs/lit.dist.js";
import {convertAjaxResponseErrorMessageToString} from "../util/errors.js";
import {GET, restRequest} from "../util/http.js";
import './pk-spinner.js';
import './pk-alert.js';

export class PkHtmlContainer extends LitElement {

    static #contentCache = {};
    #currentRequest;

    static properties = {
        src: {type: String},
        method: {type: String},
        isLoading: {type: Boolean, state: true},
        error: {type: String, state: true},
        content: {type: String, state: true},
    }

    constructor(props) {
        super(props);
        this.method = GET;
    }

    createRenderRoot() {
        return this;
    }

    async refresh() {
        this.constructor.#contentCache[this.#cacheKey] = undefined;
        return this.#fetchContent();
    }

    get #cacheKey() {
        return `${this.method} ${this.src}`;
    }

    async #fetchContent() {
        if (!this.src) {
            return;
        }

        if (this.constructor.#contentCache[this.#cacheKey]) {
            this.content = this.constructor.#contentCache[this.#cacheKey];
            return;
        }

        this.isLoading = true;
        this.content = '';
        this.error = '';
        try {
            const request = restRequest(this.method, this.src);
            this.#currentRequest = request;

            const content = await restRequest(this.method, this.src);
            if (request === this.#currentRequest) {
                this.constructor.#contentCache[this.#cacheKey] = content;
                this.content = content;
                this.#currentRequest = undefined;
            }
        } catch (e) {
            this.error = convertAjaxResponseErrorMessageToString(e);
        }
        this.isLoading = false;

    }

    update(e) {
        super.update(e);

        if (e.has('src') || e.has('method')) {
            this.#fetchContent().then();
        }

        this.setAttribute('is-loading', !!this.isLoading);
        this.setAttribute('has-error', !!this.error);

        if (e.has('content')) {
            this.#executeScripts();
        }
    }

    #executeScripts() {
        const scripts = this.querySelectorAll('script');
        let scriptTag, attr;
        for (let oldScript of scripts) {
            scriptTag  = document.createElement("script");
            scriptTag.text = oldScript.innerHTML;
            for (attr of oldScript.attributes) {
                scriptTag.setAttribute(attr.name, attr.value);
            }
            oldScript.parentNode.replaceChild(scriptTag, oldScript);
        }
    }

    render() {
        if (this.isLoading) {
            return html`<pk-spinner></pk-spinner>`
        }
        return html`
            ${this.error ? html`
                <pk-alert danger>${this.error}</pk-alert>
            ` : null}
            ${unsafeHTML(this.content)}
        `;
    }
}

if (!customElements.get('pk-html-container')) {
    customElements.define('pk-html-container', PkHtmlContainer);
}
